<div class="relative gg">
    <div class="relative flex flex-col h-[100vh] overflow-y-scroll right-tag">

      <div class="w-full flex-grow flex items-center">
        <div class="card-holder mx-auto">
          <div class="block w-full relative p-4">
            <div class="relative land-container py-8 rounded-2xl">
              <div class="login-container relative py-10 px-4  rounded-2xl move-up delay-75" style="--order: 16">

                <div class="py-2 flex justify-center">
                  <div class="bg-grey rounded-full p-2 profile-container scale-up delay-200" style="--order:18">
                    <img alt="Logo" class="max-w-max  h-[100px] rounded-full"
                         src="assets/images/user-icon.png"
                         title="Logo">
                  </div>
                </div>

                <div class="py-4 px-4">
                  <form
                    (ngSubmit)="resetPassword(resetForm.value)"
                    [formGroup]="resetForm"
                    autocomplete="off"
                    novalidate
                  >
                    <div class="block mb-3 pb-3">
                      <div class="bg-primary-50 rounded-xl p-4 text-center">
                        {{ 'Reset Password description and password policy' | concat | translate }}
                      </div>
                    </div>

                    <div class="block mb-3">
                      <mat-form-field appearance="outline">
                        <mat-label>{{ 'New Password' | concat | translate }}</mat-label>
                        <input [type]="hide ? 'password' : 'text'" formControlName="password" matInput
                              name="password"
                              placeholder="{{ 'New Password' | concat | translate }}"/>
                        <button (click)="hide = !hide" [attr.aria-label]="'Hide'" [attr.aria-pressed]="hide" mat-icon-button matSuffix
                                type="button">
                          <mat-icon class="material-icons-outlined">{{ hide ? 'visibility_off' : 'visibility' }}
                          </mat-icon>
                        </button>
                        <mat-error>
                          <span
                            *ngIf="!resetForm.get('password')?.valid && !resetForm.get('password')?.untouched">
                              {{ 'Password must match creteria defined' | concat | translate }}
                          </span>
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="block mb-3">
                      <mat-form-field appearance="outline">
                        <mat-label>{{ 'Confirm Password' | concat | translate }}</mat-label>
                        <input [type]="hide ? 'password' : 'text'" formControlName="confirmPassword" matInput
                              name="confirmPassword"
                              placeholder="{{ 'Confirm Password' | concat | translate }}"/>
                        <button (click)="hide = !hide" [attr.aria-label]="'Hide'" [attr.aria-pressed]="hide" mat-icon-button matSuffix
                                type="button">
                          <mat-icon class="material-icons-outlined">{{ hide ? 'visibility_off' : 'visibility' }}
                          </mat-icon>
                        </button>
                        <mat-error>
                          <span
                            *ngIf="!resetForm.get('confirmPassword')?.valid && !resetForm.get('confirmPassword')?.untouched">
                              {{ 'Field is required' | concat | translate }}
                          </span>
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div
                      *ngIf="
                        resetForm.get('password')?.value && resetForm.get('confirmPassword')?.value &&
                        resetForm.get('password')?.value != resetForm.get('confirmPassword')?.value
                      "
                      class="block mb-3 pb-3"
                    >
                      <div class="bg-red-100 rounded-xl text-red-700 p-4">
                        {{ 'The Password and Confirm Password must be the same' | concat | translate }}
                      </div>
                    </div>

                    <div class="flex gap-2 items-center move-up" style="--order:6">
                      <button
                        [ngClass]="resetForm?.valid ?' !bg-primary text-white':'!bg-grey/50 text-gray-500'"
                        class="flex-grow flex gap-5 justify-center items-center !h-10 rounded-lg"
                        type="submit"
                        [disabled]="!resetForm.valid || loading">
                        <span class="block p-2 text-md">{{ 'Change Password' | concat | translate }} </span>
                      </button>
                      <mat-progress-spinner
                        color="primary" [diameter]="30" mode="indeterminate"
                        *ngIf="loading"
                      ></mat-progress-spinner>
                    </div>
                  </form>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
